import { takeEvery, put } from 'redux-saga/effects';
import { createAction } from 'redux-actions';
import { toastTypes } from 'constants/toastr';
import * as actions from 'components/common/toaster/toastr-actions';

import {} from 'constants/action-types';
import { Action } from 'types/action';

const {
  actionTypes: { TOAST_MESSAGE }
}: { actionTypes: { TOAST_MESSAGE: string } } = actions;

function* throwErrorToast(action: Action) {
  if (action.meta && action.meta.toastOptions && action.meta.toastOptions.errorMessage) {
    yield put(
      createAction(TOAST_MESSAGE, () => {
        const newMessage = action.meta.toastOptions?.errorMessage;

        return {
          message: newMessage,
          toastType: toastTypes.error
        };
      })()
    );
  }
}

function* throwSuccessToast(action: Action) {
  if (action.meta && action.meta.toastOptions && action.meta.toastOptions.successMessage) {
    yield put(
      createAction(TOAST_MESSAGE, () => ({
        message: action.meta.toastOptions?.successMessage,
        toastType: toastTypes.success
      }))()
    );
  }
}

export default function* toastSaga() {
  yield takeEvery([], throwSuccessToast);

  yield takeEvery([], throwErrorToast);
}
